
































































































































import Vue from "vue";
import moment from "moment";
import apiClient from "@/services/apiClient";

export default Vue.extend({
  data() {
    return {
      items: [],
      totalItem: null,
      users: [],
      currentUser: null,
      currentDate: "",
      loading: false,
      headers: [
        { text: this.$t("PACKAGE_ID"), value: "package_id" },
        { text: "Tiền vận chuyển", value: "fee_transport" },
        { text: "Phí ủy thác", value: "fee_trust" },
        { text: "Phí dịch vụ", value: "fee_service" },
        { text: "Lợi nhuận thanh toán", value: "profit" },
        { text: "Tổng lợi nhuận", value: "package_profit" },
        { text: "Còn nợ", value: "debt" },
        { text: "Ngày về VN", value: "truck_vn_time" },
        { text: "Ngày thanh lý", value: "liquidation_time" },
      ],
      timeModes: [
        {
          value: "month",
          text: "Tháng",
        },
        {
          value: "year",
          text: "Năm",
        },
      ],
      timeMode: "month",
    };
  },
  watch: {
    currentUser() {
      this.initialize();
    },
    currentDate() {
      this.initialize();
    },
    timeMode() {
      this.initialize();
    },
  },
  methods: {
    async initialize() {
      if (!this.currentUser || !this.currentDate) {
        return;
      }
      const m = moment(this.currentDate);
      this.loading = true;
      const options: any = {
        filters: [],
        extra: {
          statistics: true,
          truck_statistics: true,
          truck_vn_time: {
            from: m.startOf(this.timeMode).unix(),
            to: m.endOf(this.timeMode).unix(),
          },
        },
        report: true,
      };
      if (this.currentUser.id) {
        options.filters.push({
          key: "customer_id",
          operator: "=",
          value: this.currentUser.id,
        });
      }
      let { items } = await apiClient.packageGetAll(options);
      items = items.map((item) => {
        if (item.truck && item.truck_total_volume) {
          item.cost =
            (item.volume / item.truck_total_volume) *
            item.truck.export_fee_total;
        } else {
          item.cost = 0;
        }

        item.package_profit =
          item.fee_transport + item.fee_trust + item.profit - item.cost;
        return item;
      });

      this.totalItem = items.reduce(
        (totalItem, item) => {
          totalItem.fee_transport += item.fee_transport;
          totalItem.fee_trust += item.fee_trust;
          totalItem.fee_service += item.fee_service;
          totalItem.profit += item.profit;
          totalItem.package_profit += item.package_profit;
          totalItem.debt += item.debt;
          return totalItem;
        },
        {
          fee_transport: 0,
          fee_trust: 0,
          fee_service: 0,
          profit: 0,
          package_profit: 0,
          debt: 0,
        }
      );

      this.items = items;
      this.loading = false;
    },
  },
  async created() {
    this.currentDate = this.$route.query.date || moment().format("YYYY-MM");

    const { items } = await apiClient.customerGetAll({
      report: true,
    });
    items.unshift({
      name: "ALL",
    });
    for (const user of items) {
      this.users.push(user);
      if (user.id == this.$route.params.id) {
        this.currentUser = user;
      }
    }
  },
});
